import './expired.css';
import exp from './expired.png';

export default function Expired() {
    return (
        <div className="wms-expired-container">
            <img className="wms-expired-logo" src={exp} alt="WMS Warning Logo" />
            <div className="wms-expired-msg">This link is invalid or has expired.</div>
        </div>);
}